module.exports = __webpack_public_path__ + "static/img_4241-2dd4f599d381650d553d0191f1af452f.jpg";